import * as actionCreators from 'client/redux/fstd/actionCreators';
import { INSTANCE_FSTD_FILE_TEST } from 'client/redux/fstd/constants';

export const instanceFstdFileTest = (instanceId, method) => dispatch => dispatch(actionCreators.instanceFstdFileTest(INSTANCE_FSTD_FILE_TEST, instanceId, method));

